module.exports = __webpack_public_path__ + "static/media/booking_retail.3935cfa9.svg";